import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import {
  getDashboardInfo,
  updatePackageRankNotification
} from '../views/Dashboard/Dashboard.actions';
import {
  DashboardInformation,
  Discount,
  LastRegisteredUsers,
  WillyDataResponse
} from '../views/Dashboard/Dashboard.types';

interface dashboardSliceType {
  loading: boolean;
  dashboardInfo: DashboardInformation | null;
  lastRegisteredUsers: LastRegisteredUsers[];
  joinedAfterCount: number;
  discountCodes: Discount[];
}

const initialState = {
  loading: false,
  dashboardInfo: null,
  lastRegisteredUsers: [],
  joinedAfterCount: 0,
  discountCodes: []
} as dashboardSliceType;

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    removeDashboardState(state) {
      state = initialState;
    },
    removeUsedDiscount(state, { payload }) {
      state.discountCodes = state.discountCodes.filter(
        (discount) => discount.userDiscountCode !== payload
      );
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getDashboardInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDashboardInfo.fulfilled, (state, { payload }) => {
      const now = moment();
      const midnight = moment.utc().startOf('day');

      const secondsSinceMidnight = now.diff(midnight, 'seconds');

      state.loading = false;
      state.dashboardInfo = payload.dashboardInfo;
      state.lastRegisteredUsers = payload.lastRegisteredUsers;
      state.joinedAfterCount = payload.joinedAfterCount;
    });
    builder.addCase(getDashboardInfo.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(updatePackageRankNotification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      updatePackageRankNotification.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        if (state.dashboardInfo) {
          const filtered =
            state.dashboardInfo.packageRankUpgradeNotifications.filter(
              (item) => item.id !== payload
            );
          state.dashboardInfo.packageRankUpgradeNotifications = filtered;
        }
      }
    );
    builder.addCase(updatePackageRankNotification.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { removeDashboardState, removeUsedDiscount } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
